<template>
    <div>
        <div>
            <ul class="nav nav-tabs nav-justified">
                <li class="nav-item">
                    <a class="nav-link" @click.prevent="setActive('tab1')" :class="{ active: isActive('tab1') }" href="#tab1">Новости</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" @click.prevent="setActive('tab2')" :class="{ active: isActive('tab2') }" href="#tab2">Руководство пользователя</a>
                </li>
            </ul>
        </div>


        <div class="tab-content mt-4" id="myTabContent">
            <div class="tab-pane fade" :class="{ 'active show': isActive('tab1') }" id="tab1">
                <news-list></news-list>
            </div>
            <div class="tab-pane fade" :class="{ 'active show': isActive('tab2') }" id="tab2">
                <manual></manual>
            </div>
        </div>
    </div>
</template>
<script>
import NewsList from "@/modules/settings/components/NewsList"
import Manual from "@/modules/settings/components/Manual"
import security from "@/common/mixins/security";
import Constants from '@/common/constants';
export default {
    name: "Settings",
    components: {
        NewsList, Manual
    },
    mixins: [security],
    data() {
        return {
            activeItem: 'tab1',
        }
    },
    created() {
      this.checkPermission(Constants.SettingsAccess).then(response => {
        if (response.data !== true) {
          Constants.alert.fire('Ошибка', "У вас нет доступа к данной странице", 'error');
          this.$router.push({path: '/'});
        }
      });
    },
    methods: {
        isActive (menuItem) {
            return this.activeItem === menuItem
        },
        setActive (menuItem) {
            this.activeItem = menuItem
        }
    },
}
</script>
<style lang="scss" scoped>
@import "/src/assets/theme/default/colors.scss";
.nav-tabs {
  justify-content: center;
  border: none;
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
  .nav-item {
    margin-top: 12px;
    max-width: 240px;
    width: 100%;
    min-width: 205px;
    margin-right: 8px;
    margin-left: 8px;
    .nav-link {
      padding: 14.5px 20px;
      text-align: center;
      font-family: "Source Sans Pro", sans-serif;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 120%;
      color: $gray-dark;
      border: 1px solid $gray-light1;
      box-sizing: border-box;
      border-radius: 6px;

      &.active {
        color: $blue-light;
        border: 1px solid $blue-light;
      }
    }
  }
}
</style>